@if (visible$ | async) {
  @for (alert of alerts$ | async; track alert) {
    <app-admin-alert
      class="alert--spacing"
      [level]="alert.level"
      [message]="alert.message"
      [isClosable]="alert.is_closable"
      (dismiss)="onDismiss(alert.id)"
    />
  }
}
